import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { normalizeBizTableColumns } from '@/utils/tableColumns';


export default /*@__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props, { expose: __expose }) {

const visible = ref(false);
const loading = ref(false);
const tableRef = ref<any>();
const storeId = ref<number>(0);
const storeName = ref('');

const conditionsInitValue = {
  dateRange: [
    dayjs()
      .subtract(7, 'day')
      .format('YYYY-MM-DD'),
    dayjs()
      .format('YYYY-MM-DD'),
  ],
};

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([
  {
    name: 'dateRange',
    label: '时间范围',
    type: 'datepick',
    pickType: 'daterange',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期',
    fastPick: [
      {
        name: '近7日',
        handler: (formdata) => {
          formdata.dateRange = [
            dayjs().subtract(6, 'day')
              .format('YYYY-MM-DD'),
            dayjs().format('YYYY-MM-DD'),
          ];
        },
        dateChangeHandler: ([start, end]) => dayjs().format('YYYY-MM-DD') === end && dayjs(end).subtract(6, 'day')
          .format('YYYY-MM-DD') === start,
      },
      {
        name: '近30日',
        handler: (formdata) => {
          formdata.dateRange = [
            dayjs().subtract(29, 'day')
              .format('YYYY-MM-DD'),
            dayjs().format('YYYY-MM-DD'),
          ];
        },
        dateChangeHandler: ([start, end]) => dayjs().format('YYYY-MM-DD') === end && dayjs(end).subtract(29, 'day')
          .format('YYYY-MM-DD') === start,
      },
    ],
    isCondition: true,
    hideTable: true,
  },
  {
    name: 'storeName',
    label: '店铺名称',
    type: 'string',
  },
  {
    name: 'syncTime',
    label: '统计日期',
    type: 'string',
  },
  {
    name: 'openCount',
    label: '开门次数',
    type: 'numberStr',
    width: 80,
  },
  {
    name: 'openPeople',
    label: '开门人数',
    type: 'numberStr',
    width: 80,
  },
]));

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const dateRange = filter.conditions.dateRange as string[] | undefined;
    const res = await useApi().storeStatisticsApi.pageStoreStatisticsstoreStatistics({
      storeId: storeId.value,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
      start: dateRange?.[0] ? dayjs(dateRange[0]).format('YYYY-MM-DD') : undefined,
      end: dateRange?.[1] ? dayjs(dateRange[1]).format('YYYY-MM-DD') : undefined,
    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const show = (row: any) => {
  storeId.value = row.id;
  storeName.value = row.name || '';
  visible.value = true;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!

  return (_openBlock(), _createBlock(_component_HpsfirProDrawer, {
    open: visible.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: `${storeName.value} - 统计详情`,
    width: "80vw",
    "max-width": "1200px",
    "content-class": "business-table-drawer",
    "body-class": "business-table-drawer__body"
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_HpsfirProTable, {
            key: 0,
            ref_key: "tableRef",
            ref: tableRef,
            "export-file-name": "门店统计详情",
            title: "",
            paginations: { pageSize: 10 },
            columns: columns.value,
            "get-data": _unref(getData),
            loading: loading.value,
            "row-key": "id",
            "codition-init-values": conditionsInitValue
          }, null, 8, ["columns", "get-data", "loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["open", "title"]))
}
}

})